<script setup>
const toast = useToast();
const emits = defineEmits(["onSave", "onClose"]);

const { data: sessionData, getSession } = useAuth();

const { data: countries } = useFetch("/api/countries");
const { data: scores } = useFetch("/api/scores");

const academicPayload = ref({});

const updateAcademic = (data) => {
  academicPayload.value = {
    ...academicPayload.value,
    ...data,
  };
};

const onSaveAcademicData = async (data) => {
  academicPayload.value = {
    ...data,
  };
};

const submitAcademic = async () => {
  await useApiFetch("profile/update/academic", {
    method: "POST",
    body: academicPayload.value,
    async onResponse() {
      emits("onSave");
      toast.add({
        severity: "success",
        summary: "Academic information has been saved.",
        life: 3000,
        closable: false,
      });
      getSession();

      emits("onClose");
    },
  });
};

onMounted(() => {
  academicPayload.value.country_of_education =
    sessionData?.value?.data?.agent_profile?.country_of_education;
  academicPayload.value.english_test_score =
    sessionData?.value?.data?.agent_profile?.english_test_score;
});
</script>

<template>
  <form @submit.prevent="submitAcademic">
    <div class="px-8 py-5 space-y-6 border-t border-b border-slate-200">
      <div class="space-y-1">
        <Label>Country of education</Label>
        <Select
          v-model="academicPayload.country_of_education"
          :options="countries"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Country"
          class="w-full placeholder:text-xs lg:placeholder:text-sm text-[#4B5563] text-xs lg:text-sm"
          fluid
        />
      </div>
      <div class="space-y-1">
        <Label>English Test Score</Label>
        <Select
          v-model="academicPayload.english_test_score"
          :options="scores"
          optionLabel="label"
          optionValue="value"
          placeholder="Select English Test Score"
          class="w-full placeholder:text-xs lg:placeholder:text-sm text-[#4B5563] text-xs lg:text-sm"
          fluid
        />
      </div>

      <div class="space-y-2">
        <Label isRequired>Academic background</Label>

        <AcademicInfo :showEdit="true" @onChange="updateAcademic" />
      </div>
    </div>

    <div class="px-8 py-5 flex justify-end gap-3">
      <Button
        label="Cancel"
        class="min-w-28"
        outlined
        @click="emits('onClose')"
      ></Button>
      <Button label="Submit" class="min-w-28" type="submit"></Button>
    </div>
  </form>
</template>
